<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="businessco_name_from" [ttModel]="edit.businessco_name_from" ttReadonly></tt-input>
        <tt-input ttLabel="businessco_name_to" [ttModel]="edit.businessco_name_to" ttReadonly></tt-input>
        <tt-date ttLabel="deliverydate_tom" [ttModel]="edit.deliverydate_tom" ttReadonly></tt-date>
        <tt-date ttLabel="invoice_date" [(ttModel)]="edit.invoice_date"></tt-date>
        <tt-input ttLabel="invoice_valuta_id" [ttModel]="edit.invoice_valuta_id" ttReadonly></tt-input>
        <tt-input-number ttLabel="amount_to_invoice_invval" [ttModel]="edit.amount_to_invoice_invval" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-textarea *ngIf="!!edit.errorinfo" ttLabel="errorinfo" [ttModel]="edit.errorinfo" ttReadonly></tt-textarea>
        <tt-button-save *ngIf="edit.show_create_invoice_button === '1'" ttText="orderheadmi_create_invoice" (ttClick)="createChanges()" [ttLoading]="creating"></tt-button-save>
    </tt-card>
</tt-page>
